<app-base-notification [base]="base">
  <div *ngIf="!isMicroText()" [innerHTML]="'notifications.content_comment.text' | translate: {'user': user, 'title': contentTitle}"></div>
  <div *ngIf="isMicroText()" [innerHTML]="'notifications.content_comment.text_post' | translate: {'user': user, 'title': microTextTitle}"></div>
</app-base-notification>
